import React from "react";
import { Link, NavLink, Navigate } from "react-router-dom";
import { useI18n } from "../i18n/I18nProvider";

export default function LocalizedLink({ to, ...rest }) {
  const { localePath } = useI18n();
  return <Link to={localePath(to)} {...rest} />;
}

export function LocalizedNavLink({ to, ...rest }) {
  const { localePath } = useI18n();
  return <NavLink to={localePath(to)} {...rest} />;
}

export function LocalizedNavigate({ to, ...rest }) {
  const { localePath } = useI18n();
  return <Navigate to={localePath(to)} {...rest} />;
}
